"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulaAmplitudeAdapter = exports.DEFAULT_AMPLITUDE_OPTIONS = void 0;
const amplitude = __importStar(require("@amplitude/analytics-browser"));
const events_1 = require("@pathccm/common-analytics/events");
const rula_common_plugin_1 = __importDefault(require("./plugins/rula-common-plugin"));
const plugin_session_replay_browser_1 = require("@amplitude/plugin-session-replay-browser");
exports.DEFAULT_AMPLITUDE_OPTIONS = {
    serverUrl: "https://t.rula.com/2/httpapi",
    autocapture: {
        attribution: true,
        sessions: true,
        // Deemed too noisy / less valuable to product for now
        pageViews: false,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
    },
};
class RulaAmplitudeAdapter {
    apiKey;
    productArea;
    userId;
    userType;
    plugins;
    commonPlugin;
    amplitudeOptions;
    static isAmplitudeInitialized = false;
    constructor({ apiKey, productArea, userId, userType, plugins = [], amplitudeOptions = exports.DEFAULT_AMPLITUDE_OPTIONS, }) {
        this.apiKey = apiKey;
        this.productArea = productArea;
        this.userId = userId;
        this.plugins = plugins;
        this.commonPlugin = new rula_common_plugin_1.default(productArea, userType);
        this.amplitudeOptions = amplitudeOptions;
        if (!RulaAmplitudeAdapter.isAmplitudeInitialized &&
            typeof window !== "undefined") {
            this.init();
            RulaAmplitudeAdapter.isAmplitudeInitialized = true;
        }
    }
    init() {
        amplitude.init(this.apiKey, this.userId, {
            serverUrl: this.amplitudeOptions.serverUrl,
            ...this.amplitudeOptions,
        });
        this.identify({
            userId: this.userId,
            properties: { user_type: this.userType },
        });
        // Add session replay feature. Sessions sampled at rate specified in Amplitude Settings UI
        const sessionReplayTracking = (0, plugin_session_replay_browser_1.sessionReplayPlugin)();
        this.plugins.push(this.commonPlugin);
        this.plugins.push(sessionReplayTracking);
        for (const plugin of this.plugins) {
            amplitude.add(plugin);
        }
    }
    track(trackEvent) {
        const eventName = `${trackEvent.eventName.prefix}_${trackEvent.eventName.trigger}`;
        amplitude.track(eventName, trackEvent.properties);
    }
    identify(identifyEvent) {
        if (identifyEvent.userId) {
            amplitude.setUserId(identifyEvent.userId);
        }
        const identify = new amplitude.Identify();
        for (const [key, value] of Object.entries(identifyEvent.properties)) {
            identify.set(key, value instanceof Date ? value.toISOString() : value);
        }
        amplitude.identify(identify);
    }
    page(pageEvent) {
        amplitude.track(`${pageEvent.prefix}_${events_1.Trigger.PAGE_LOAD}`, {
            page: pageEvent.name,
            category: pageEvent.category,
            ...pageEvent.properties,
        });
    }
}
exports.RulaAmplitudeAdapter = RulaAmplitudeAdapter;
//# sourceMappingURL=rula-amplitude-adapter.js.map